import React from 'react'
import { UserProvider } from './providers/UserProvider'
import { UnsavedChangesProvider } from './providers/UnsavedChangesProvider'

const Main = ({ children }) => (
  <UserProvider>
    <UnsavedChangesProvider>{children}</UnsavedChangesProvider>
  </UserProvider>
)

export default Main
